package com.milta.core.localization.translations.es

import com.milta.core.localization.AiCreditStrings

internal val AiCredit = AiCreditStrings(
    aiMark = "IA",
    menuAiLegend = "IA: lectura automática por inteligencia artificial, que usa su crédito de IA. Para Excel, solo si las columnas no se reconocen.",
    menuExhaustedTitle = "Crédito de IA agotado — se reinicia el {date}.",
    menuExhaustedMessage = "El escaneo y la importación de PDF están desactivados. Una hoja de cálculo con las columnas esperadas y la entrada manual siguen disponibles.",
    modeDisabledReason = "Crédito de IA agotado",
    exhaustedBannerWebTitle = "Crédito de IA agotado — se reinicia el {date}.",
    exhaustedBannerWebMessage = "Los PDF ya no se pueden analizar. Importe un archivo Excel o CSV con las columnas esperadas o añada las entregas a mano desde la aplicación móvil.",
    dropConstraintsWithoutPdf = "Excel (.xlsx, .xls) o CSV · máx. 500 paradas · 10 MB",
    pdfUnavailableUntil = "PDF no disponible hasta el {date}",
    pdfRefusedTitle = "Crédito de IA agotado — este PDF no se puede analizar",
    pdfRefusedMessage = "«{file}» requiere una lectura por IA. Su crédito vuelve el {date}. Mientras tanto, importe un archivo Excel o CSV con las columnas esperadas o añada las entregas a mano desde la aplicación móvil.",
    spreadsheetExhaustedTitle = "Columnas no reconocidas — crédito de IA agotado",
    spreadsheetExhaustedWebMessage = "Las columnas de «{file}» no corresponden a las columnas esperadas y su crédito de IA ya no permite identificarlas automáticamente (vuelve el {date}). Cambie el nombre de las columnas como se indica abajo o añada las entregas a mano desde la aplicación móvil.",
    expectedColumnsNoCreditHint = "Un archivo que respeta estas columnas se importa sin IA y no consume crédito, incluso al 0 %.",
    importExhaustedTitle = "Crédito de IA agotado",
    importExhaustedPhotoMessage = "Su crédito de IA llegó al 0 % mientras esta importación esperaba. La foto no se analizó y no se descontó nada. Se reinicia el {date}.",
    importExhaustedFileMessage = "Su crédito de IA llegó al 0 % mientras esta importación esperaba. El archivo no se analizó y no se descontó nada. Se reinicia el {date}.",
    importSpreadsheetExhaustedMessage = "Las columnas de este archivo no corresponden a las columnas esperadas y su crédito de IA ya no permite identificarlas automáticamente. Se reinicia el {date}.",
    stepPhotoSent = "Foto enviada",
    stepFileSent = "Archivo enviado: {file}",
    stepAnalysisNotStarted = "Análisis no iniciado: crédito de IA agotado",
    stepFileRead = "Archivo leído: {file}",
    stepExpectedColumns = "Columnas esperadas: Nombre del destinatario, Dirección completa",
    stepDeliveriesKept = "Las entregas ya introducidas se conservan",
    retryAvailableOn = "Reintentar — disponible el {date}",
    manualEntryAction = "Entrada manual",
    myUsageTitle = "Mi uso",
    myUsageAttachedDriverNote = "Aquí solo aparecen tus propias acciones. Lo que tus empresas lanzan por ti se descuenta en su cuenta.",
    tabOptimizations = "Optimizaciones",
    tabAiCredit = "Crédito de IA",
    remainingForPeriod = "Crédito de IA restante en el periodo",
    percentValue = "{percent} %",
    remainingSuffix = "de crédito de IA restante",
    lowPill = "Crédito bajo",
    exhaustedPill = "Agotado · escaneo e importación de PDF desactivados",
    driverNote = "Su crédito vuelve al renovarse la suscripción (la de su Empresa si forma parte de una). El crédito no utilizado no se acumula.",
    enterpriseNote = "Vuelve al renovarse su suscripción, sin acumulación. Este crédito solo cubre sus propias acciones de IA; cada conductor tiene el suyo.",
    exhaustedNote = "La entrada manual y las hojas de cálculo con las columnas esperadas siguen disponibles. El crédito vuelve al renovarse su suscripción.",
    webScopeHint = "Este crédito solo cubre las acciones de IA de esta cuenta: escaneos, importaciones de PDF o foto, columnas de hoja de cálculo no reconocidas. Cada conductor tiene el suyo.",
    profileValue = "{optimizations} · IA {percent} %",
    profileValueAiOnly = "IA {percent} %",
    columnShare = "Parte del crédito",
    actionScanDeliveryList = "Escaneo de lista",
    actionScanPackageLabel = "Escaneo de etiqueta",
    actionImportPdf = "Importación de PDF",
    actionImportUnstructured = "Importación en segundo plano",
    actionSpreadsheetMapping = "Columnas de hoja de cálculo (IA)",
    outcomeSuccess = "Correcto",
    outcomeFailed = "Fallido",
    outcomeUnreadable = "Ilegible",
    countedSuffix = "(descontado)",
    rowDateTime = "{date} a las {time}",
    limitsEyebrow = "Crédito de IA por periodo",
    limitsDescription = "Importe en euros que cada cuenta puede consumir en llamadas de IA (escaneos, importaciones de PDF o foto, columnas de hoja de cálculo no reconocidas) por periodo de suscripción. El crédito vuelve al límite al renovarse la suscripción, sin acumulación.",
    weightedEquivalent = "≈ {tokens} tokens ponderados",
    limitsFootnote = "Un conductor de una Empresa recibe el límite «Conductor», de prueba mientras su Empresa esté en prueba. El equivalente en tokens es orientativo y se recalcula con el tipo de cambio indicado abajo.",
    conversionEyebrow = "Conversión y alerta",
    rateLabel = "Tipo de cambio",
    rateHint = "Actualizado a mano · se aplica a las llamadas siguientes",
    thresholdLabel = "Alerta de crédito bajo",
    thresholdUnit = "% restante",
    thresholdHint = "Porcentaje en naranja y banner una vez por periodo",
    calculationTitle = "Cómo se calcula el coste de una llamada.",
    calculationBody = "Claude Haiku 4.5: 1 $ por millón de tokens de entrada, 5 $ por millón de tokens de salida. Token ponderado = entrada × 1 + salida × 5, por lo tanto 1 $ = 1.000.000 tokens ponderados. Coste en euros = coste en dólares ÷ tipo de cambio. Ejemplo: un escaneo de lista medio (5.014 entrada + 1.792 salida) = 13.974 tokens ponderados = 0,014 $ ≈ 0,013 €.",
    settingsSavedTitle = "Límites guardados.",
    settingsSavedDetail = "Empresa: {enterpriseTrial} prueba · {enterprisePaid} de pago. Conductor: {driverTrial} prueba · {driverPaid} de pago. Tipo de cambio {rate}. Alerta {threshold} %.",
    limitTooHigh = "Máximo 1.000 €.",
    rateTooHigh = "Máximo 10.",
    thresholdOutOfRange = "Entre 1 y 99.",
    adminCreditTitle = "Crédito de IA",
    adminRemainingLine = "≈ {tokens} tokens ponderados restantes · consumido {consumed}",
    adminOverrunLine = "Consumido {consumed} · exceso de {over}",
    adminLowPill = "Crédito bajo · por debajo del {threshold} %",
    adminLowPillNoThreshold = "Crédito bajo",
    adminExhaustedPill = "Crédito agotado · acciones de IA desactivadas",
    adminAppliedAfterReplacement = "{consumed} consumidos + {remaining} restantes (sustitución)",
    adminGlobalLimitLabel = "Límite global",
    adminGlobalLimitResumes = "{source} — vuelve a aplicarse en el reinicio",
    adminResetNoCarryOver = "Vuelve a {limit}: el exceso no se arrastra",
    replaceLabel = "Sustituir el crédito restante",
    replaceHelp = "De 0 a 100 €, solo para el periodo actual. En el reinicio, la cuenta vuelve a partir del límite global.",
    replaceHelpEnterpriseDriver = "Solo modifica el crédito de {name}. El de la Empresa y el de los demás conductores no cambia.",
    replaceInvalid = "Introduzca un importe de 0 a 100 €.",
    replacedTitle = "Crédito restante sustituido: {from} → {to}.",
    replacedDetail = "Para el periodo actual. El {date}, vuelta al límite global ({limit}).",
    adminHistoryTitle = "Historial del crédito de IA",
    adminPeriodSummary = "Periodo actual desde el {start}: {calls} llamadas · {failed} fallidas o ilegibles (descontadas) · {tokens} tokens ponderados · {consumed}",
    columnInput = "Entrada",
    columnOutput = "Salida",
    columnWeighted = "Ponderados",
    columnCost = "Coste",
    decimalSeparator = ",",
    importExhaustedNeutralMessage = "Su crédito de IA está agotado. El archivo no se analizó y no se descontó nada. Se reinicia el {date}.",
    rateUnitPrefix = "1 € =",
    rateUnitSuffix = "\$",
)
